import { render, staticRenderFns } from "./sjyyJnrh.vue?vue&type=template&id=053988c7&scoped=true"
import script from "./sjyyJnrh.vue?vue&type=script&lang=js"
export * from "./sjyyJnrh.vue?vue&type=script&lang=js"
import style0 from "./sjyyJnrh.vue?vue&type=style&index=0&id=053988c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053988c7",
  null
  
)

export default component.exports